<li class="nav-item client-select-wrapper" id="clientSelect" *ngIf="isShowing && clients && clients.length > 0">
  <span class="client-label">Client:</span>
  <select #clientSelect class="client-select" (change)="onChange($event)">
    <option *ngFor="let client of clients" [value]="client.tenantId">
      {{client.name}}
    </option>
  </select>
</li>
 

